import React from "react";
import {Checkbox, Col} from "antd";
import {
    BooleanSelectFilter,
    CityFilter,
    CourierFilter,
    CourierInvoiceAccountStatusFilter,
    SearchText
} from "../../../../_defaultComponents/FilterComponents";

export const InactiveCourierWalletsTabFilters = ({filters, setFilters}) => {
    return (
        <React.Fragment>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <h5>Kurye (İsim, tckn, telefon)</h5>
                <CourierFilter
                    value={filters.courierId}
                    onChange={value => setFilters({...filters, page: 1, courierId: value})}
                    allowClear={true}
                    selectMarginBottom="0px"
                    activity="disabled"
                    hideTitle={true}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <CourierInvoiceAccountStatusFilter
                    value={filters.courierInvoiceAccountStatus}
                    onChange={value =>
                        setFilters({...filters, page: 1, courierInvoiceAccountStatus: value})
                    }
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <CityFilter
                    value={filters.city}
                    onChange={value => setFilters({...filters, page: 1, city: value})}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <BooleanSelectFilter
                    title="Para Çekim Talebi Var mı?"
                    trueLabel="Var"
                    falseLabel="Yok"
                    value={filters.hasActiveWithdrawRequest}
                    onChange={value =>
                        setFilters({...filters, page: 1, hasActiveWithdrawRequest: value})
                    }
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <BooleanSelectFilter
                    title="Onay Bekleyen Fatura Var mı?"
                    trueLabel="Var"
                    falseLabel="Yok"
                    value={filters.hasPendingInvoice}
                    onChange={value => setFilters({...filters, page: 1, hasPendingInvoice: value})}
                />
            </Col>
            <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                <h5 style={{visibility: "hidden"}}>-</h5>
                <div style={{minHeight: 32, display: "flex", alignItems: "center"}}>
                    <Checkbox
                        checked={!!filters.isInvoiceExpected}
                        onChange={e =>
                            setFilters({
                                ...filters,
                                page: 1,
                                isInvoiceExpected: e.target.checked || undefined
                            })
                        }
                    >
                        Fatura/Para Çekim Talebi Oluşturulması Gereken Kuryeleri Göster
                    </Checkbox>
                </div>
            </Col>
        </React.Fragment>
    );
};

export default InactiveCourierWalletsTabFilters;
